import { EditorObject } from 'utils/responsiveTypes'

const conditionKey = (object: EditorObject, property: string): string => {
  const { id } = object

  return `${id}:${property}`
}

export default conditionKey
